export const lg_joinmeetbtid = {
    lg_joinmeetbtid_th: {
      title: "เข้าร่วมการประชุมผ่าน Dmeets",
      subtitle1: "กรุณากรอกรหัสการประชุมที่ท่านได้รับเพื่อเข้าร่วมการประชุม",
      subtitle2: "ข้อมูลการประชุมทั้งหมดถูกจัดเก็บในประเทศไทย",
      subtitle3: "Dmeets รับรองว่าการประชุมออนไลน์ของคุณปลอดภัยและเป็นไปตามกฎหมาย PDPA ข้อมูลการประชุมทั้งหมดของคุณจะไม่ถูกจัดเก็บไว้นอกประเทศไทย",
      formlabel:"เข้าร่วมประชุมด้วย Meeting ID",
      formplaceholder:"รหัสการประชุม",
      buttonjoin:"เข้าร่วมการประชุม",
      put_required:"ใส่รหัสการประชุม!!!",
    },
    lg_joinmeetbtid_en: {
      title: "Join a Meeting on Dmeets",
      subtitle1: "Please enter the Meeting ID you received to join the meeting.",
      subtitle2: "Your meeting is secure. All data is stored in Thailand.",
      subtitle3: "Dmeets ensure your online meetings are safe and PDPA-compliant. All of your meetings will not be stored outside of Thailand.",
      formlabel:"Join Meeting with ID",
      formplaceholder:"Meeting ID",
      buttonjoin:"Join Meeting",
      put_required:"Meeting ID required",
    },
  };
